import {
  StyleSheet,
  View,
  Modal,
  TouchableOpacity,
  Image,
  TextInput,
  Clipboard,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import React, { memo } from "react";
import Cross from "@assets/svg/CrossIcon";
import { useNavigation } from "@react-navigation/native";
import toast from "@utils/toast";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { REFER_EARN } from "@constants/analyticsEventsCT";
import { useSelector } from "react-redux";
import Text from "../../components/CustomText";

const LIKED_RED = "#E40046";

const PATH = "screens/ReferEarn";

const OtherReferModal = memo(({ show, close, referralLink, phoneNumber }) => {
  const { LEADER_TO_LEADER_REFERRAL } =
    useSelector(({ configReducer }) => configReducer.appSettings) || {};

  const { REFERRAL_MODAL } = LEADER_TO_LEADER_REFERRAL;

  const navigation = useNavigation();

  const handleNavigateToReferQRScreen = () => {
    close();
    navigation.navigate("ReferQRScreen", {
      referralLink,
    });
  };

  const copyToClipboard = () => {
    Clipboard.setString(phoneNumber);
    toast.showShortToast(t(`${PATH}/codeCopied`));
    analytics.trackEvent(REFER_EARN.REFER_REFER_NOW, {
      screen: "Refer Side Menu",
      medium: "Signup code",
    });
  };

  return (
    <Modal
      visible={show}
      transparent
      statusBarTranslucent
      navigationBarTranslucent
    >
      <KeyboardAvoidingView
        style={styles.flex}
        behavior={Platform.OS === "ios" ? "padding" : "height"}
      >
        <View style={styles.container}>
          <View style={styles.modalContainer}>
            <TouchableOpacity style={styles.closeButton} onPress={close}>
              <Cross />
            </TouchableOpacity>
            <Image
              source={{ uri: REFERRAL_MODAL }}
              style={styles.modalImage}
              resizeMode="cover"
            />
            <Text variant="caption_1" style={styles.titleText}>
              {t(`${PATH}/inviteFriends`)}
            </Text>
            <Text variant="caption_2" style={styles.subTitleText}>
              {t(`${PATH}/chooseType`)}
            </Text>
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 20,
              }}
              onPress={handleNavigateToReferQRScreen}
            >
              <View style={{ marginRight: 10 }}>
                <Image
                  source={{ uri: referralLink }}
                  style={{ width: 20, height: 20 }}
                />
              </View>
              <Text variant="caption_2" style={styles.qrCtaText}>
                {t(`${PATH}/referFromQRCode`)}
              </Text>
            </TouchableOpacity>
            <View style={styles.codeContainer}>
              <Text variant="caption_2" style={styles.codeTitleText}>
                {t(`${PATH}/copyCodekare`)}
              </Text>
              <View style={{ flexDirection: "row" }}>
                <TextInput value={phoneNumber} style={styles.codeTextInput} />
                <TouchableOpacity
                  style={styles.codeCtaButton}
                  onPress={copyToClipboard}
                >
                  <Text variant="caption_2" style={styles.codeCtaText}>
                    {t(`${PATH}/copyCode`)}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </KeyboardAvoidingView>
    </Modal>
  );
});

export default OtherReferModal;

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  container: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    flex: 1,
    justifyContent: "center",
  },
  modalContainer: {
    margin: 15,
    padding: 20,
    backgroundColor: "#fff",
    alignItems: "center",
    borderRadius: 15,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  modalImage: {
    width: 100,
    height: 65,
  },
  titleText: {
    fontSize: 16,
    fontWeight: "700",
    color: "rgba(0, 0, 0, 0.86)",
    marginTop: 25,
  },
  subTitleText: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: 12,
    fontWeight: "400",
  },
  qrCtaText: {
    color: LIKED_RED,
    fontSize: 14,
    lineHeight: 25,
    fontWeight: "500",
    textAlignVertical: "center",
  },
  codeContainer: {
    borderTopWidth: 1,
    borderTopColor: "rgba(0, 0, 0, 0.1)",
    width: "100%",
    marginTop: 20,
  },
  codeTitleText: {
    marginTop: 12,
    marginBottom: 5,
    fontWeight: "500",
    fontSize: 14,
    lineHeight: 30,
  },
  codeTextInput: {
    borderWidth: 1,
    height: 42,
    padding: 0,
    paddingLeft: 10,
    borderRadius: 8,
    borderColor: "rgba(0, 0, 0, 0.2)",
    flex: 1,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  codeCtaButton: {
    height: 42,
    alignItems: "center",
    justifyContent: "center",
    width: 92,
    borderRadius: 8,
    backgroundColor: "rgba(228, 0, 70, 0.1)",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderWidth: 1,
    borderColor: LIKED_RED,
  },
  codeCtaText: {
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 30,
    color: LIKED_RED,
  },
});
